// Third Party
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

// Constants Library
import {
  ROOT_CONSTANT,
  TEMPLATE,
} from "../../../../constants";

// Components Library
import { TablePagination, BtnSubmit } from "../../../../components";
import { CreateCompanyDrawer } from "../DrawerCreateEditCompany";

// Styles Library
import classes from "../../../../pages/index.module.css";

const { BTN_IMG } = TEMPLATE.BTN;
const { icon_filter } = ROOT_CONSTANT.IMG.ICON;

const CreateCompany = (props) => {
  const {
    setIsModalOpen,
    pageSize,
    setPageSize,
    filteredDataCount,
    handlePaginatedDataChange,
    current,
    setCurrent,
    tabKey,
    data,
  } = props;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <CreateCompanyDrawer
        setIsDrawerOpen={setIsDrawerOpen}
        isDrawerOpen={isDrawerOpen}
      />
      <div className={classes.headerPage}>
        <div className={classes.headerWrap}>
          <div className={classes.headerSubStart}>
            <BtnSubmit
              display="inline-block"
              text="Filter"
              bgColor="transparent"
              color="black"
              padding="9px 18px"
              marginTop="2px"
              fontWeight="700"
              border="1px solid #DDDDDD"
              outline="#DDDDDD"
              onClick={() => setIsModalOpen(true)}
              showIcon={true}
              icon={icon_filter}
              icon_alt={"filter"}
            />
          </div>
          <TablePagination
            tabKey={tabKey}
            data={data}
            filteredDataCount={filteredDataCount}
            onPaginatedDataChange={handlePaginatedDataChange}
            pageSize={pageSize}
            setPageSize={setPageSize}
            current={current}
            setCurrent={setCurrent}
          />
        </div>
        <div className={classes.headerSubEnd}>
          <BtnSubmit
          display={"inline-block"}
          text={"Create Company"}
          bgColor="#0E2483"
          color="white"
          padding="9px 18px"
          marginTop="-2px"
          outline="#0E2483"
          border="1px solid #0E2483"
          onClick={() => {
            setIsDrawerOpen(true);
          }}
          showIcon={true}
          icon={BTN_IMG.ADD_WHITE}
          icon_alt={"create"}
          />
        </div>
      </div>
    </>
  );
};

export default CreateCompany;
